import { useCallback, useContext, useEffect, useState } from "react";
import Select, { components } from "react-select";
import { UserContext } from "../../../Context/UserContext";
import { debounce } from "lodash";
import { BaseURL } from "../../../Reusable/BaseURL";
import ClipLoader from "react-spinners/ClipLoader";
import AsyncSelect from "react-select/async";

export const GenEIndentSelect = ({
  selectedOption,
  setSelectedOption,
  changingSelect,
  setChangingSelect,
  getIndent,
  setEnquiryIndent,
}) => {
  const { darkTheme, loginData } = useContext(UserContext);

  const [options, setOptions] = useState([]);
  // const [inputValue, setInputValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Fetch initial data on component mount
  // useEffect(() => {
  //   const fetchInitialData = async () => {
  //     try {
  //       if (selectedOption !== "") {
  //         setIsLoading(true)
  //         const response = await fetch(
  //           `${BaseURL}/cities?q=${selectedOption}`,
  //           {
  //             method: "GET",
  //             headers: {
  //               Accept: "application/json",
  //               Authorization: `Bearer ${loginData.token}`,
  //             },
  //           }
  //         );
  //         const data = await response.json();
  //         const myFilter = data.data.data.filter(
  //           (item) => item.name === selectedOption
  //         );
  //         const transformedOptions = myFilter.map((item) => ({
  //           value: item.id,
  //           label: item.name,
  //         }));
  //         const myFind = transformedOptions.find(
  //           (item) => item.label === selectedOption
  //         );
  //         setSelectedOption(myFind);
  //         if(data.status===true || data.status === false){
  //           setIsLoading(false)
  //           }
  //       }
  //     } catch (error) {
  //       console.error("Error fetching initial data:", error);
  //     }
  //   };
  //   fetchInitialData();
  // }, [changingSelect]);

  // Function to fetch data based on input
  // const fetchData = useCallback(
  //   debounce(async (input) => {
  //     setIsLoading(true)
  //     const API_URL = `${BaseURL}/cities?q=${input}`;
  //       const response = await fetch(API_URL, {
  //         method: "GET",
  //         headers: {
  //           Accept: "application/json",
  //           Authorization: `Bearer ${loginData.token}`,
  //         },
  //       });
  //       const data = await response.json();
  //       const transformedOptions = data.data.data.map((item) => ({
  //         value: item.id,
  //         label: item.name,
  //       }));
  //       setOptions(transformedOptions);
  //       if(data.status===true || data.status === false){
  //         setIsLoading(false)
  //         }
  //   }, 300),
  //   []
  // );

  // const fetchInitialData = async () => {
  //   setIsLoading(true);
  //   const response = await fetch(`${BaseURL}/purchase/enquiry/getopenindents`, {
  //     method: "GET",
  //     headers: {
  //       Accept: "application/json",
  //       Authorization: `Bearer ${loginData.token}`,
  //     },
  //   });
  //   const data = await response.json();
  //   const transformedOptions = data.data.map((item) => ({
  //     value: item.id,
  //     label: item.code,
  //     division: item.division,
  //     date: item.date,
  //     severity: item.severity,
  //   }));
  //   setOptions(transformedOptions);
  //   if (data.status === true || data.status === false) {
  //     setIsLoading(false);
  //   }
  // };

  // Function to load options based on user input
  const loadOptions = (inputValue, callback) => {
    fetch(`${BaseURL}/purchase/enquiry/getopenindents?q=${inputValue}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        const options = data.data.map((item) => ({
          value: item.id,
              label: item.code,
              division: item.division,
              date: item.date,
              severity: item.severity,
        }));
        callback(options);
        // return options;
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        callback([]);
        // return [];
      });
  };
  const debouncedLoadOptions = debounce(loadOptions, 400);

  // const handleFocus = () => {
  //   // fetchData(inputValue);
  //   fetchInitialData()
  // };

  // // Handle input change
  // const handleInputChange = (newValue) => {
  //   setInputValue(newValue);
  //   // fetchData(newValue);
  // };

  // Handle option select
  const handleChange = (selectedOption) => {
    setEnquiryIndent([])
    setSelectedOption(selectedOption);
    if(selectedOption?.value){
      getIndent(selectedOption.value);
    }
  };

  // Custom styling
  const customStyles = {
    // loading style
    // menuList: (provided) => ({
    //   ...provided,
    //   display: "flex",
    //   justifyContent: "center",
    //   alignItems: "center",
    //   minHeight: "50px",
    //   flexDirection: "column",
    //   textTransform: "uppercase",
    // }),
    container: (provided) => ({
      ...provided,
      width: "100%",
      margin: "0 auto",
      color: `${darkTheme ? "white" : "black"}`,
    }),
    control: (provided) => ({
      ...provided,
      backgroundColor: `${darkTheme ? "#374151" : "#ffff"}`,
      borderColor: "none",
      boxShadow: "none",
      "&:hover": {
        borderColor: "none",
      },
      borderRadius: "8px",
      border: "none",
      padding: "0 2px",
      color: `${darkTheme ? "white" : "black"}`,
      textTransform: "uppercase",
      border: `${darkTheme ? "1px solid #6B7280" : "1px solid #6B7280"}`,
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "4px",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      backgroundColor: `${darkTheme ? "#374151" : "#ffff"}`,
      textTransform: "uppercase",
      border: "1px solid #6B7280",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#2a60a0"
        : state.isFocused
        ? "#0ffa"
        : darkTheme
        ? "#374151"
        : "#ffff",
      color: state.isSelected ? "white" : "black",
      "&:active": {
        backgroundColor: "#aad",
        color: "white",
      },
      padding: "4px 10px",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "black",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "black",
      fontWeight: "400",
      fontSize: "14px",
      textTransform: "uppercase",
    }),
  };

  const MenuList = (props) => {
    const { isLoading, children } = props;
    return (
      <components.MenuList {...props}>
        {isLoading ? (
          <div
            style={
              {
                // display: "flex",
                // flexDirection: "row",
                // justifyContent: "center",
                // alignItems: "center",
                // height: "100%",
              }
            }
          >
            <ClipLoader color="#000" loading={isLoading} size={30} />
          </div>
        ) : (
          children
        )}
      </components.MenuList>
    );
  };

  return (
    <AsyncSelect
      // onFocus={handleFocus}
      styles={customStyles}

      cacheOptions
      loadOptions={debouncedLoadOptions}
      defaultOptions

      // options={options}
      // onInputChange={handleInputChange}
      // inputValue={inputValue}
      onChange={handleChange}
      value={selectedOption}
      placeholder="Select"
      isLoading={isLoading}
      // components={{
      //   MenuList: (props) => <MenuList {...props} isLoading={isLoading} />,
      // }}
      closeMenuOnSelect={true}
      className="react-select-container"
      classNamePrefix="react-select"
      isClearable
    />
  );
};
